import { useState, useEffect } from 'react'
import { getImmobilierHistory } from '../services/api.js'

export function useImmobilierHistory(autoLoad = false) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [searches, setSearches] = useState([])

  const load = async () => {
    setLoading(true)
    setError(null)
    try {
      const data = await getImmobilierHistory()
      setSearches(data.searches || [])
    } catch (err) {
      setError(err?.message || 'Erreur chargement historique')
      setSearches([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (autoLoad) load()
  }, [autoLoad])

  return { loading, error, searches, load }
}
